import { AuthN, getConfig } from '@seek/online-identity';

// Singleton AuthN instance to avoid re-initialization across the application
let authNInstance: AuthN | null = null;
let authNPromise: Promise<void> | null = null;

/**
 * Gets or initializes the singleton AuthN instance.
 * This ensures we only have one AuthN instance across the entire application,
 * avoiding multiple initializations and maintaining session consistency.
 */
export const getAuthN = async (): Promise<AuthN> => {
  if (authNInstance) {
    return authNInstance;
  }

  // If initialization is in progress, wait for it
  if (authNPromise) {
    await authNPromise;

    return authNInstance!;
  }

  // Initialize AuthN
  const host = typeof window !== 'undefined' ? window.location.host : '';
  authNInstance = new AuthN(getConfig('seekAnz-candidate', { host }));

  authNPromise = authNInstance.init();
  await authNPromise;
  authNPromise = null;

  return authNInstance;
};

/**
 * Resets the AuthN singleton instance.
 * Useful for testing or when a fresh instance is needed.
 */
export const resetAuthN = () => {
  authNInstance = null;
  authNPromise = null;
};
